import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { getCurrentDate } from '../../../utils/general'
import { enqueueNotification } from '../../../redux/slices/notificationsSlice'
import { useDispatch, useSelector } from 'react-redux'
import Header from './components/Header/Header'
import { useReportsAccountsARAgingMutation } from '../../../services'
import FilteringModal from './components/FilteringModal/FilteringModal'
import ReceivablesAgingTableBlock from './components/ReceivablesAgingTableBlock/ReceivablesAgingTableBlock'
import { UspReportAccountsReceivableAgingResult } from '../../../models'
import { appRoute } from '../../../constants'
import { useNavigate } from 'react-router-dom'
import { getUserAccessRights } from '../../../redux/slices/authSlice'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import { Card, Container } from '@mui/material'

const AccountsReceivableAging = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userAccess = useSelector(getUserAccessRights)
  const [showTable, setShowTable] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(true)
  const [formValues, setFormValues] = useState<any>(null)

  const [filterReceivables, { data: filterData, isSuccess: filterIsSuccess, isLoading: filterIsLoading }] = useReportsAccountsARAgingMutation()

  const handleOpenFilterModal = () => setOpenFilterModal(true)
  const handleCloseFilterModal = () => setOpenFilterModal(false)

  const handleSubmit = (values: any) => {
    const jsonBranchList = values?.Branch?.map((item: any) => ({ BranchID: item?.BranchID }))
    const jsonLenderList = values?.Lender?.map((item: any) => ({ LenderID: item?.ID }))
    const jsonDealerList = values?.Dealer?.map((item: any) => ({ DealerID: item?.ID }))
    const jsonCollectorList = values?.Collector?.map((item: any) => ({ FinderID: item?.ID }))
    filterReceivables({
      uspReportAccountsReceivableCommon: {
        asOfDate: getCurrentDate(),
        isIncludeLenderServicedDeals: values.isIncludeLenderServicedDeals || false,
        isShowPrincipalForPC: values.isShowPrincipalForPC || false,
        isIncludePickups: values.isIncludePickups || false,
        jsonBranchList: jsonBranchList || null,
        jsonLenderList: jsonLenderList || null,
        jsonDealerList: jsonDealerList || null,
        jsonCollectorList: jsonCollectorList || null,
      },
    })
    setFormValues(values)
  }

  useEffect(() => {
    if (filterIsSuccess) {
      handleCloseFilterModal()
      setShowTable(true)
      dispatch(enqueueNotification({ message: 'Success' }))
    }
  }, [filterIsSuccess])

  useEffect(() => {
    if (!userAccess.CanAccessAccountInsights) {
      dispatch(
        enqueueNotification({
          message:
            'Access Denied: Sorry, your current access rights do not permit you to enter this section. If you believe you should have access, please contact your system administrator or help desk for assistance.',
          options: { variant: 'error' },
        }),
      )
      navigate(appRoute.Home)
    }
  }, [userAccess, appRoute])

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CustomBreadcrumbs
        heading='Reports'
        links={[
          {
            href: appRoute.Insights,
            name: 'List',
          },
          {
            name: 'Receivables Aging',
          },
        ]}
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Card
        sx={{
          height: { xs: 800, md: 2 },
          flexGrow: { md: 1 },
          display: { md: 'flex' },
          flexDirection: { md: 'column' },
        }}
      >
        <Form
          onSubmit={handleSubmit}
          keepDirtyOnReinitialize
          initialValues={{ isShowPrincipalForPC: false, isIncludeLenderServicedDeals: false, isIncludePickups: false }}
        >
          {({ handleSubmit }: any) => (
            <form onSubmit={handleSubmit}>
              {showTable && (
                <Header handleOpenFilterModal={handleOpenFilterModal} filterData={filterData as UspReportAccountsReceivableAgingResult[]} />
              )}
              <FilteringModal formValues={formValues} open={openFilterModal} handleClose={handleCloseFilterModal} />
              {showTable && (
                <ReceivablesAgingTableBlock filterData={filterData as UspReportAccountsReceivableAgingResult[]} isLoading={filterIsLoading} />
              )}
            </form>
          )}
        </Form>
      </Card>
    </Container>
  )
}

export default AccountsReceivableAging
